import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../Eventdetail/detail.css';
import Seatbuy from '../ManagerSeat/seatbuy';
import axios from 'axios';
import ZoneEditor from "../ManagerSeat/zoneditor"
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal'; // Si usas React Modal
import { FaMusic, FaMapMarkerAlt, FaCalendarAlt, FaTheaterMasks, FaClock, FaChair } from 'react-icons/fa';
import { getShows } from '../Redux/Actions/actions';

// import Generaltribunes from './generaltribune';
// Agrega esta configuración inicial si aún no lo hiciste
Modal.setAppElement('#root');

const Detail = () => {
  const { id } = useParams();
  const showId = Number(id); // Convertir a número si es necesario
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const shows = useSelector((state) => state.shows);
  const loading = useSelector((state) => state.loading);
  const error = useSelector((state) => state.error);
  const [zoneData, setZoneData] = useState([]);
  const [isSeatManagerOpen, setIsSeatManagerOpen] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState([]);
  // const [availableSeats, setAvailableSeats, handleSeatsSelected] = useState([]);
  const [availableSeats, setAvailableSeats] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [zoneImage, setZoneImage] = useState(null); // Mapa general al principio
  const [zonesLoaded, setZonesLoaded] = useState(false);
  const canvasRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);  // Nuevo estado para cargar
  const [seatsDrawn, setSeatsDrawn] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Para almacenar la fila seleccionada
  const [rows, setRows] = useState([]); // Para almacenar las filas disponibles de una zona
  const [seatsInRow, setSeatsInRow] = useState([]); // Para almacenar los asientos disponibles en la fila seleccionada
  const [isZoneEditorOpen, setIsZoneEditorOpen] = useState(false);
  const [selectedSeat, setSelectedSeat] = useState(null);  // El asiento seleccionado desde el select
  const [presentation, setPresentations] = useState([]); // Fechas y horarios obtenidos de la acción
  const [selectedPresentation, setSelectedPresentation] = useState({
    date: '',
    time: ''
  });
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);
  const [availablePresentations, setAvailablePresentations] = useState([]);
  const [timer, setTimer] = useState(10 * 60);  // 20 minutos en segundos
  const [countdownStarted, setCountdownStarted] = useState(false); // Para evitar que inicie más de una vez
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null); // Aquí almacenarás la información de la división
  const user = useSelector((state) => state.user);
  const [showMap, setShowMap] = useState(false); // El mapa está oculto por defecto
  // Buscar el evento en el array de shows
  const event = shows.find((show) => show.id === parseInt(id));
  const isFloresta = event?.template === "Floresta";
  const handleSeatsSelected = () => { };
  const isExternalImage = zoneImage && !zoneImage.startsWith(window.location.origin);
  const [imageLoaded, setImageLoaded] = useState(false);


  const openModal = (data) => {
    setModalData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  ///ASIGNACION DE PERMISOS POR EVENTOS///
  useEffect(() => {
    if (!event || !user) return;

    // Si tiene assignedEvents y no está vacío, solo puede ver esos eventos
    if (user.assignedEvents && user.assignedEvents.length > 0) {
      if (!user.assignedEvents.includes(event.id)) {
        Swal.fire({
          icon: "error",
          title: "Acceso restringido",
          text: "No tienes permiso para ver este evento",
        }).then(() => {
          navigate("/");
        });
      }
    }
    // Si assignedEvents no existe o está vacío, puede ver todo
  }, [event, user, navigate]);


  const florestaImgRef = useRef(null);

  useEffect(() => {
    if (!showMap || !isFloresta) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    if (!florestaImgRef.current) {
      florestaImgRef.current = new Image();
      florestaImgRef.current.src = "/images/zona-floresta.png";
    }

    const img = florestaImgRef.current;

    setImageLoaded(false);

    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // pequeño delay = estabilidad total
      setTimeout(() => {
        setImageLoaded(true);
      }, 30);
    };

    // ⚠️ por si ya estaba cargada (cache)
    if (img.complete) {
      img.onload();
    }

  }, [showMap, isFloresta]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !zoneImage) return;

    const ctx = canvas.getContext("2d");
    const img = new Image();

    setImageLoaded(false);

    img.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      setImageLoaded(true); // 🔥 clave
    };

    img.src = zoneImage;
  }, [zoneImage]);


  useEffect(() => {

    if (!showMap) return; // Si showMap es false, no hacemos nada

    if (!id) {
      console.error("id no está definido, no se puede cargar la imagen del mapa.");
      return;
    }

    const fetchZones = async () => {
      try {
        const response = await axios.get("/zones"); // Ruta correcta de la API
        if (response.status === 200) {
          const zones = response.data.zones;

          // Filtrar zonas por showId
          const matchingZones = zones.filter((zone) => zone.showId === Number(id));

          if (matchingZones.length > 0) {
            // console.log("Zonas encontradas para el show:", matchingZones);

            // Asignar imagen basada en zoneId
            matchingZones.forEach((zone) => {
              switch (zone.id) {
                case 1:
                  setZoneImage("/images/zona-floresta.png");
                  break;
                case 2:
                  setZoneImage("/images/movistar-arena.jpg");
                  break;
                default:
                  setZoneImage(null);
              }
            });
          } else {
            console.warn(`No se encontraron zonas para el showId: ${id}`);
            setZoneImage(null);
          }
        }
      } catch (error) {
        console.error("Error al cargar las zonas:", error);
      }
    };

    fetchZones();
  }, [showMap, id]); // Se ejecuta solo cuando el id cambia

  useEffect(() => {
    dispatch(getShows());
  }, [dispatch]);

  // Este efecto se ejecuta cuando zonesLoaded cambia, forzando la actualización del estado
  useEffect(() => {
    if (zonesLoaded && isFloresta) {
      setZoneImage("/images/zona-floresta.png");
    }
  }, [zonesLoaded, isFloresta]);

  //efectos de prueba de logs///

  useEffect(() => {

  }, [availablePresentations]);

  useEffect(() => {
    if (event?.location) {

    }
  }, [event?.location]);

  useEffect(() => {

  }, [zoneData]);

  useEffect(() => {

  }, [selectedZone]);


  // 
  // Filtrar los asientos disponibles cuando se seleccione una zona
  const fetchSeatsForZone = async (divisionName, showId) => {
    try {
      const response = await axios.get("/zones");
      if (response.status === 200) {
        const zones = response.data.zones;

        // Filtrar las zonas por showId y divisionName
        const matchedZones = zones.filter(
          (zone) =>
            zone.showId === showId &&
            zone.location.some((loc) => loc.division === divisionName)
        );

        if (matchedZones.length > 0) {
          // Crear el array de presentaciones con lógica adaptada
          const presentations = matchedZones.map((zone) => {
            const presentation = event.presentation[0];
            const generalTicket = zone.generalTicket ?? false; // Asegurar que no sea undefined
            const generalPrice = zone.location.find(
              (loc) => loc.division === divisionName
            )?.generalPrice || 0;

            // Asignar generalTicket según la fecha y hora de la presentación
            const isCorrectTime = presentation.time.start && presentation.time.end;

            return {
              zoneId: zone.id,
              divisionName: divisionName,
              presentation: presentation,
              location: zone.location,
              space: zone.space || zone.location.find(loc => loc.division === divisionName)?.space || 0,
              generalPrice: generalPrice,
              generalTicket: isCorrectTime ? generalTicket : false, // Aquí asignamos el valor dinámicamente
            };
          });


          // console.log('Presentations:', presentations);
          setAvailablePresentations(presentations);
          setIsSelectorOpen(true);
        } else {
          console.log("");
        }
      }
    } catch (error) {
      console.error("Error al cargar las divisiones:", error);
    }
  };


  const handleRowChange = (e) => {
    const value = e.target.value;

    setSelectedRow(value);

    const rowData = rows.find(
      (row) => String(row.row).trim() === String(value).trim()
    );

    setSeatsInRow(rowData?.seats ?? []);
  };


  useEffect(() => {
    if (selectedZone && availableSeats.length > 0) {
      setRows(availableSeats); // cada fila ya tiene `division` y `zoneId`
    }
  }, [selectedZone, availableSeats]);

  const handleCanvasClick = (e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;


    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);

    const scaledX = x / zoom;
    const scaledY = y / zoom;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });

    // 🔹 Detectar si click fue sobre un asiento
    let clickedSeat = [];
    if (seatsDrawn && selectedZone !== "Floresta") {
      clickedSeat = availableSeats.flatMap((seatRow) =>
        seatRow.seats.filter((seat) => {
          const { x: sx, y: sy, radius } = seat.drawingPosition || {};
          if (sx === undefined || sy === undefined || radius === undefined) return false;
          const distance = Math.sqrt(Math.pow(scaledX - sx, 2) + Math.pow(scaledY - sy, 2));
          return distance <= radius;
        })
      );
    }

    // 🔹 SOLO REDIBUJAR si NO se hizo click sobre un asiento
    if (!isFloresta && seatsDrawn && clickedSeat.length === 0) {
      drawSeats(ctx);
    }

    const isExternalImage = zoneImage && (zoneImage.startsWith("http") || zoneImage.startsWith("https"));

    // 🔴 SOLO FLORESTA: usar getImageData si NO es externa y no se hizo click en asiento
    if (isFloresta && !isExternalImage && !selectedZone) {
      const pixel = ctx.getImageData(scaledX, scaledY, 1, 1).data;

      const rgb = `rgb(${pixel[0]}, ${pixel[1]}, ${pixel[2]})`;

      if (rgb === "rgb(232, 58, 61)" || rgb === "rgb(108, 41, 43)") {
        setSelectedZone("Preferencial");
        setZoneImage("/images/zona-roja.png");
        fetchSeatsForZone("Preferencial", event.id, selectedZoneId);
      } else if (rgb === "rgb(0, 168, 89)" || rgb === "rgb(13, 50, 34)") {
        setSelectedZone("Vip");
        setZoneImage("/images/zona-verde.png");
        fetchSeatsForZone("Vip", event.id, selectedZoneId);
      } else if (
        rgb === "rgb(245, 133, 52)" ||
        rgb === "rgb(194, 74, 44)" ||
        rgb === "rgb(245, 134, 52)" ||
        rgb === "rgb(212, 45, 49)" ||
        rgb === "rgb(155, 33, 35)"
      ) {
        setSelectedZone("Gold");
        setZoneImage("/images/zona-Gold.png");
        fetchSeatsForZone("Gold", event.id, selectedZoneId);
      } else if (rgb === "rgb(255, 242, 18)" || rgb === "rgb(47, 48, 20)") {
        setSelectedZone("Platea Sur");
        setZoneImage("/images/Platea-Sur.png");
        fetchSeatsForZone("Platea Sur", event.id, selectedZoneId);
      } else if (rgb === "rgb(0, 175, 239)" || rgb === "rgb(17, 36, 60)") {
        setSelectedZone("Platea Norte");
        setZoneImage("/images/Platea-Norte.png");
        fetchSeatsForZone("Platea Norte", event.id, selectedZoneId);
      } else if (rgb === "rgb(236, 38, 143)") {
        setSelectedZone("Tribunas Generales");
        setZoneImage("/images/Popular-Alta.png");
        setAvailableSeats([]);
        setSeatsDrawn(false);
        fetchSeatsForZone("Tribunas Generales", event.id, selectedZoneId);
      } else {
        setSelectedZone(null);

        if (isFloresta) {
          const canvas = canvasRef.current;
          if (canvas && florestaImgRef.current) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(florestaImgRef.current, 0, 0, canvas.width, canvas.height);
          }
        } else {
          setZoneImage("/images/zona-floresta.png");
        }
      }

      return; // 🔹 Salir para que no interfiera la zona dinámica
    }


    // 🔹 Solo para zonas dinámicas
    if (seatsDrawn && selectedZone !== "Floresta") {
      const clickedSeat = availableSeats.flatMap((seatRow) =>
        seatRow.seats.filter((seat) => {
          const { x: sx, y: sy, radius } = seat.drawingPosition || {};
          if (sx === undefined || sy === undefined || radius === undefined) return false;
          const distance = Math.sqrt(Math.pow(scaledX - sx, 2) + Math.pow(scaledY - sy, 2));
          return distance <= radius;
        })
      );

      if (clickedSeat.length > 0) {
        const seat = clickedSeat[0];

        if (seat.taken || seat.disabled) {
          Swal.fire({
            icon: "error",
            title: "¡Asiento no disponible!",
            text: seat.taken
              ? "Este asiento ya está ocupado, selecciona otro."
              : "Division no disponible por el momento.",
          });
          return;
        }

        const seatRow = availableSeats.find((row) =>
          row.seats.some((s) => s.uniqueId === seat.uniqueId)
        );

        const selectedZoneInfo = availablePresentations.find(
          (p) =>
            p.divisionName === selectedZone &&
            p.presentation.date === selectedPresentation.date &&
            p.presentation.time.start === selectedPresentation.time.start
        );

        const selectedZoneId = selectedZoneInfo?.zoneId ?? null;
        const price = selectedZoneInfo?.generalTicket
          ? selectedZoneInfo.generalPrice
          : seatRow?.rowPrice ?? 0;

        const seatInfo = {
          ...seat,
          row: seatRow?.row ?? null,
          price,
          division: selectedZone,
          zoneId: selectedZoneId,
          showId: event.id,
        };

        // setSelectedSeats((prev) => {
        //   const alreadySelected = prev.some((s) => s.uniqueId === seatInfo.uniqueId);
        //   const updated = alreadySelected
        //     ? prev.filter((s) => s.uniqueId !== seatInfo.uniqueId)
        //     : [...prev, seatInfo];

        //   const canvas = canvasRef.current;
        //   if (canvas) {
        //     const ctx = canvas.getContext("2d");
        //     drawSeats(ctx);
        //   }

        //   return updated;
        // });

        setSelectedSeats((prev) => {
          const alreadySelected = prev.some(
            (s) => s.uniqueId === seatInfo.uniqueId
          );

          return alreadySelected
            ? prev.filter((s) => s.uniqueId !== seatInfo.uniqueId)
            : [...prev, seatInfo];
        });

      } else {
        Swal.fire({
          icon: "error",
          title: "¡Presiona sobre un asiento!",
          text: "Selección no válida.",
        });
      }
    }
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas && seatsDrawn) {
      const ctx = canvas.getContext("2d");
      drawSeats(ctx);
    }
  }, [selectedSeats]); // <-- se ejecuta cada vez que seleccionás o deseleccionás un asiento

  const handleConfirmSelection = (presentation) => {
    if (!availablePresentations?.length) return;

    // Guardar la presentación seleccionada
    setSelectedPresentation({
      date: presentation.presentation.date,
      time: presentation.presentation.time,
    });

    // 1️⃣ Manejo especial para divisiones generales SIN ASIENTOS
    const generalDivision = Array.isArray(presentation.location)
      ? presentation.location.find(
        (loc) =>
          String(loc.division).toLowerCase() ===
          String(presentation.divisionName).toLowerCase()
      )
      : null;

    if (
      generalDivision &&
      generalDivision.space !== undefined &&
      !Array.isArray(generalDivision.rows)
    ) {
      navigate("/generaltribune", {
        state: {
          space: generalDivision.space ?? 0,
          divisionName: generalDivision.division,
          date: presentation.presentation.date,
          time: presentation.presentation.time,
          zoneId: presentation.zoneId,
          showId: event.id,
          users: user?.id,
          cashier: user?.cashier,
          price: generalDivision.generalPrice ?? 0,
          occupied: generalDivision.occupied ?? 0,
          eventdetail: event,
        },
      });

      return;
    }

    // 2️⃣ Flujo normal para otras zonas
    const selectedZoneData = availablePresentations.find(
      (p) =>
        p.zoneId === presentation.zoneId &&
        String(p.divisionName).toLowerCase() ===
        String(presentation.divisionName).toLowerCase()
    );

    if (!selectedZoneData) {
      console.warn("No se encontró selectedZoneData para:", presentation.divisionName);
      return;
    }

    const filteredDivision = Array.isArray(selectedZoneData.location)
      ? selectedZoneData.location.find(
        (loc) =>
          String(loc.division).toLowerCase() ===
          String(presentation.divisionName).toLowerCase()
      )
      : null;

    const rowsWithSeats = Array.isArray(filteredDivision?.rows)
      ? filteredDivision.rows.map((row) => ({
        ...row,
        division: filteredDivision.division,
        zoneId: selectedZoneData.zoneId,
        generalPrice: filteredDivision.generalPrice ?? 0,
        seats: Array.isArray(row.seats)
          ? row.seats.map((seat) => ({
            ...seat,
            uniqueId: `${row.row}-${seat.id}`,
          }))
          : [],
      }))
      : [];

    // 🔥 VALIDACIÓN NUEVA
    const allSeatsTaken = rowsWithSeats.every(row =>
      row.seats.every(seat => seat.taken === true)
    );


    if (allSeatsTaken) {
      // 🔥 cerrar modal selector
      setIsSelectorOpen(false);
      Swal.fire({
        icon: "warning",
        title: "Entradas agotadas",
        text: "No quedan asientos disponibles para esta división.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        navigate("/");
      });


      return;
    }


    rowsWithSeats.forEach((row) => {
      row.seats
        .filter((s) => s.taken)
        .forEach((s) => {
         
        });
    });

    setAvailableSeats(rowsWithSeats);
    setSelectedZone(presentation.divisionName);
    setSeatsDrawn(rowsWithSeats.length > 0);

    // Dibujar asientos inmediatamente
    // const canvas = canvasRef.current;
    // if (canvas) {
    //   const ctx = canvas.getContext("2d");
    //   if (ctx) drawSeats(ctx, rowsWithSeats, presentation.divisionName);
    // }

    // Countdown
    Swal.fire({
      title: "Tienes 10 minutos para elegir un asiento y realizar la compra",
      text: "¡Presiona OK para comenzar!",
      icon: "info",
      confirmButtonText: "OK",
    }).then(() => {
      setCountdownStarted(true);
      const intervalId = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 0) {
            clearInterval(intervalId);
            window.location.href = "/";
          }
          return prev - 1;
        });
      }, 1000);
    });

    setIsSelectorOpen(false);
  };


  useEffect(() => {
    if (modalData) {

    }
  }, [modalData]);

  // useLayoutEffect(() => {
  //   if (!showMap) return; // aseguramos que el canvas ya esté renderizado

  //   const canvas = canvasRef.current;
  //   if (!canvas) return;

  //   const ctx = canvas.getContext("2d");
  //   if (!ctx) return;

  //   if (!availableSeats || availableSeats.length === 0 || !selectedZone) return;

  //   ctx.clearRect(0, 0, canvas.width, canvas.height);

  //   if (isFloresta && zoneImage) {
  //     const img = new Image();
  //     img.src = zoneImage;
  //     img.onload = () => {
  //       const scaleX = canvas.width / img.width;
  //       const scaleY = canvas.height / img.height;
  //       ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  //       drawSeats(ctx, scaleX, scaleY);
  //     };
  //   } else {
  //     drawSeats(ctx, availableSeats, selectedZone);
  //   }

  // }, [availableSeats, selectedZone, zoneImage, showMap]);


  const canvasWidth = zoneImage === "/images/Platea-Sur.png" || zoneImage === "/images/Platea-Norte.png" ? 1160 : 600; // Tamaño de canvas específico para Platea
  const canvasHeight = zoneImage === "/images/Platea-Sur.png" || zoneImage === "/images/Platea-Norte.png" ? 290 : 800; // Tamaño de canvas específico para Platea

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft = 0;
    }
  }, [showMap, zoneImage, canvasWidth]);

  useEffect(() => {

  }, [selectedZone]);


  const drawSeats = (ctx, seatsToDraw = availableSeats, zoneToDraw = selectedZone) => {

   if (!Array.isArray(seatsToDraw)) {
      // console.warn("⚠️ seatsToDraw no es un array, usando array vacío:", seatsToDraw);
      seatsToDraw = [];
    }

    if (!seatsToDraw || seatsToDraw.length === 0 || !ctx) {

      return;
    }

    const canvasWidth = canvasRef.current.width;
    const canvasHeight = canvasRef.current.height;

    let pointRadius = 9;
    let fontSize = 12;
    let separationFactorX = 2.40;
    let separationFactorY = 2.32;
    let horizontalOffset = 0;
    let verticalOffset = -50;

    let scaleX = 1;
    let scaleY = 1;

    const drawAllSeats = () => {
      let currentRow = 1;

      seatsToDraw.forEach((seatRow) => {
        if (!seatRow || !seatRow.seats || seatRow.seats.length === 0) {


          return;
        }

        const rowPrice = seatRow?.rowPrice ?? 0;

        seatRow.seats.forEach((seat) => {
          const scaledX = seat.x * scaleX * separationFactorX;
          const scaledY =
            seat.y * scaleY * separationFactorY +
            (zoneImage === "/images/Platea-Norte.png" ? 90 : 0);



          const selectedZoneInfo = availablePresentations.find(
            p => p.divisionName === zoneToDraw
          );

          const generalPrice = selectedZoneInfo?.generalPrice ?? 0;
          const generalTicket = selectedZoneInfo?.generalTicket;

          // 👇 precio final según lógica actual
          const priceToUse = generalTicket ? generalPrice : rowPrice;

          // 🔥 NUEVA REGLA: bloquear fila completa si rowPrice es 0
          const isRowBlocked = rowPrice === 0;

          // 🔥 bloque final
          const shouldBlock = seat.taken || priceToUse < 100 || isRowBlocked;

          let seatColor;

          if (shouldBlock) {
            seatColor = 'grey';
            seat.disabled = true;
          } else if (selectedSeats.some(s => s.uniqueId === seat.uniqueId)) {
            seatColor = 'blue';
            seat.disabled = false;
          } else {
            seatColor = 'green';
            seat.disabled = false;
          }
          ctx.beginPath();
          ctx.arc(scaledX, scaledY, pointRadius, 0, Math.PI * 2, false);
          ctx.fillStyle = seatColor;
          ctx.fill();
          ctx.closePath();

          ctx.fillStyle = "white";
          ctx.font = `${fontSize}px Arial`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(seat.id, scaledX, scaledY);

          seat.drawingPosition = { x: scaledX, y: scaledY, radius: pointRadius };
        });

        const rowLabelY =
          seatRow.seats[0].y * scaleY * separationFactorY +
          verticalOffset +
          (zoneImage === "/images/Platea-Norte.png" ? 90 : 0);
        ctx.fillStyle = "black";
        ctx.font = "14px Arial";
        ctx.textAlign = "center";
        ctx.fillText(`Fila ${currentRow}`, seatRow.seats[0].x * scaleX * separationFactorX + horizontalOffset, rowLabelY);

        currentRow++;
      });


      setSeatsDrawn(true);
    };

    // 🔹 Dibujar imagen de fondo si existe (Floresta preservado)
    if (zoneImage) {
      const zoneImageObj = new Image();
      zoneImageObj.src = zoneImage;

      zoneImageObj.onload = () => {


        if (zoneImage === "/images/Platea-Sur.png" || zoneImage === "/images/Platea-Norte.png") {
          const specificWidth = 4800;
          const specificHeight = 1100;
          scaleX = specificWidth / zoneImageObj.width;
          scaleY = specificHeight / zoneImageObj.height;
          pointRadius = 9;
          fontSize = 11;
          separationFactorX = 1.6;
          separationFactorY = 0.6;
          horizontalOffset = -40;
          verticalOffset = 2;
          const offsetX = -15;

          // 🔹 SOLO Platea Norte
          const offsetY =
            zoneImage === "/images/Platea-Norte.png" ? 2 : 0;

          ctx.clearRect(0, 0, canvasWidth, canvasHeight);



          ctx.drawImage(
            zoneImageObj,
            0,
            0,
            zoneImageObj.width,
            zoneImageObj.height,
            offsetX,
            offsetY,
            canvasWidth,
            canvasHeight
          );
        } else if (
          zoneImage === "/images/zona-Gold.png" ||
          zoneImage === "/images/zona-verde.png" ||
          zoneImage === "/images/zona-roja.png"
        ) {
          const specificWidth = 250;
          const specificHeight = 350;
          scaleX = specificWidth / zoneImageObj.width;
          scaleY = specificHeight / zoneImageObj.height;
        } else {
          scaleX = canvasWidth / zoneImageObj.width;
          scaleY = canvasHeight / zoneImageObj.height;
        }

        drawAllSeats(seatsToDraw);
      };
    } else {

      ///seccion dinamicas////

      // 🔹 Obtenemos datos de la zona según el divisionName
      const selectedZoneData = availablePresentations.find(
        (p) =>
          p.divisionName?.toLowerCase() === zoneToDraw?.toLowerCase()
      );

      
      if (!selectedZoneData) {
        console.warn("⚠️ No se encontró datos de la zona dinámica:", zoneToDraw);
        return;
      }

      
      // 🔹 Preparamos objeto con imagen y dimensiones
      const divisionData = selectedZoneData.location?.find(
        (loc) => loc.division === zoneToDraw
      );

      const zoneDataForDraw = {
        imageUrl: divisionData?.divisionImageUrl || null,
        imageWidth: divisionData?.divisionImageWidth || canvasWidth,
        imageHeight: divisionData?.divisionImageHeight || canvasHeight,
      };

     

      // 🔹 Función para dibujar los asientos con coordenadas proporcionales

      const drawAllSeatsDynamic = () => {

        // window.addEventListener("error", (e) => {
        //   console.error("🔥 GLOBAL ERROR:", e.error || e.message);
        // });

        // window.addEventListener("unhandledrejection", (e) => {
        //   console.error("🔥 PROMISE ERROR:", e.reason);
        // });

       
        let currentRow = 1;

        seatsToDraw.forEach((seatRow) => {
          if (!seatRow || !seatRow.seats || seatRow.seats.length === 0) return;

          const seatRadius = Math.max(3, canvasWidth * 0.008);
          const rowPrice = seatRow?.rowPrice ?? 0;

          seatRow.seats.forEach((seat) => {

            // ✅ NORMALIZADO → PIXELES CANVAS
            const rect = window.dynamicImageRect;

            if (!rect) {
              console.error("❌ [DYNAMIC] dynamicImageRect todavía no está disponible");
              return;
            }

            const scaledX =
              rect.offsetX + (seat.x * rect.drawWidth);

            const scaledY =
              rect.offsetY + (seat.y * rect.drawHeight);

            const selectedZoneInfo = availablePresentations.find(
              p => p.divisionName === zoneToDraw
            );

            const generalPrice = selectedZoneInfo?.generalPrice ?? 0;

            const generalTicket = selectedZoneInfo?.generalTicket;

            // 👇 misma lógica que Floresta
            const priceToUse = generalTicket
              ? generalPrice
              : rowPrice;

            const isRowBlocked = rowPrice === 0;

            const shouldBlock =
              seat.taken ||
              priceToUse < 100 ||
              isRowBlocked;

            let seatColor;

            if (shouldBlock) {
              seatColor = 'grey';
              seat.disabled = true;
            } else if (
              selectedSeats.some(s => s.uniqueId === seat.uniqueId)
            ) {
              seatColor = 'blue';
              seat.disabled = false;
            } else {
              seatColor = 'green';
              seat.disabled = false;
            }

            ctx.beginPath();
            ctx.arc(scaledX, scaledY, seatRadius, 0, Math.PI * 2);
            ctx.fillStyle = seatColor;
            ctx.fill();
            ctx.closePath();

            ctx.fillStyle = "white";
            ctx.font = `bold ${seatRadius}px Arial`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(seat.id, scaledX, scaledY);

            seat.drawingPosition = {
              x: scaledX,
              y: scaledY,
              radius: seatRadius
            };
          });

          const xs = seatRow.seats.map(s => s.x * canvasWidth);
          const ys = seatRow.seats.map(s => s.y * canvasHeight);

          // centro horizontal de la fila
          const centerX = (Math.min(...xs) + Math.max(...xs)) / 2;

          // parte más baja de la fila
          const bottomY = Math.max(...ys);

          // label abajo de la fila
          ctx.fillStyle = "black";
          ctx.font = `bold ${seatRadius}px Arial`;
          ctx.textAlign = "center";
          ctx.textBaseline = "top";

          currentRow++;
        });
        
        setSeatsDrawn(true);
      };


      // 🔹 Dibujar imagen si existe
      if (zoneDataForDraw.imageUrl) {

        const img = new Image();

        img.onerror = (e) => {
          console.error("❌ [DYNAMIC] ERROR CARGANDO IMAGEN", {
            url: zoneDataForDraw.imageUrl,
            error: e,
          });
        };

        img.src = zoneDataForDraw.imageUrl;

        img.onload = () => {

          const canvas = canvasRef.current;

          if (!canvas) {
            console.error("❌ [DYNAMIC] canvas todavía no está disponible");
            return;
          }

          const ctx = canvas.getContext("2d");

          if (!ctx) {
            console.error("❌ [DYNAMIC] no se pudo obtener contexto 2D");
            return;
          }

          const canvasRatio = canvas.width / canvas.height;
          const imgRatio = img.width / img.height;

          let drawWidth, drawHeight, offsetX, offsetY;

          if (imgRatio > canvasRatio) {
            drawWidth = canvas.width;
            drawHeight = canvas.width / imgRatio;

            offsetX = 0;
            offsetY = (canvas.height - drawHeight) / 2;
          } else {
            drawHeight = canvas.height;
            drawWidth = canvas.height * imgRatio;

            offsetX = (canvas.width - drawWidth) / 2;
            offsetY = 0;
          }

          ctx.clearRect(0, 0, canvas.width, canvas.height);

          window.dynamicImageRect = {
            offsetX,
            offsetY,
            drawWidth,
            drawHeight
          };

          ctx.drawImage(
            img,
            0,
            0,
            img.width,
            img.height,
            offsetX,
            offsetY,
            drawWidth,
            drawHeight
          );

          drawAllSeatsDynamic();
        };
      } else {

        drawAllSeatsDynamic();

      }

    }
  };

  ////TERMINA FUNCION ASIENTOS DE ZONAS DINAMICAS //////


  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // 🔹 Solo dibujar si hay zona seleccionada y asientos disponibles
    if (availableSeats && availableSeats.length > 0 && selectedZone) {
      drawSeats(ctx, availableSeats, selectedZone);
    }
  }, [availableSeats, selectedZone, zoneImage]);



  const loadImage = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (zoneImage) {
      const img = new Image();
      img.src = zoneImage;
      setImageLoaded(false); // 🔴 reset
      img.onload = () => {
        const scaledWidth = canvas.width * zoom;
        const scaledHeight = canvas.height * zoom;
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, scaledWidth, scaledHeight);
        setImageLoaded(true); // ✅ ahora sí
        drawSeats(ctx);
      };
    } else {
      // Sin imagen: dibujar solo los asientos
      drawSeats(ctx);
    }
  };


  // opcional: que siempre arranque scrolleado a la izquierda


  useEffect(() => {
    if (!showMap) return;

    // Detectar celular
    const isMobile = window.innerWidth < 768;

    // Mostrar solo una vez
    // const alreadyShown = localStorage.getItem("zoomTipShown");

    if (isMobile) {
      Swal.fire({
        title: "Consejo",
        text: "Usá los dedos para hacer zoom y facilitar la selección de asientos.",
        icon: "info",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#2563eb",
      });

      localStorage.setItem("zoomTipShown", "true");
    }
  }, [showMap]);



  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const selectSeat = (seat) => {
    if (!seat || seat.taken || seat.disabled) {
      Swal.fire({
        icon: "error",
        title: "Asiento no disponible",
      });
      return;
    }

    const seatRow = availableSeats.find((row) =>
      row.seats.some((s) => s.uniqueId === seat.uniqueId)
    );

    const selectedZoneInfo = availablePresentations.find(
      (p) =>
        p.divisionName === selectedZone &&
        p.presentation.date === selectedPresentation.date &&
        p.presentation.time.start === selectedPresentation.time.start
    );

    const price = selectedZoneInfo?.generalTicket
      ? selectedZoneInfo.generalPrice
      : seatRow?.rowPrice ?? 0;

    const seatInfo = {
      ...seat,
      row: seatRow?.row ?? null,
      price,
      division: selectedZone,
      zoneId: selectedZoneInfo?.zoneId ?? null,
      showId: event.id,
    };

    // setSelectedSeats((prev) => {
    //   const exists = prev.some((s) => s.uniqueId === seatInfo.uniqueId);

    //   const updated = exists
    //     ? prev.filter((s) => s.uniqueId !== seatInfo.uniqueId)
    //     : [...prev, seatInfo];

    //   const canvas = canvasRef.current;
    //   if (canvas) {
    //     const ctx = canvas.getContext("2d");
    //     drawSeats(ctx);
    //   }

    //   return updated;
    // });
    setSelectedSeats((prev) => {
      const exists = prev.some((s) => s.uniqueId === seatInfo.uniqueId);

      return exists
        ? prev.filter((s) => s.uniqueId !== seatInfo.uniqueId)
        : [...prev, seatInfo];
    });
  };

  const handleSelectSeatFromDropdown = (e) => {
    const value = e.target.value;

    // 🔥 TODA LA FILA
    if (value === "ROW_ALL") {
      const available = seatsInRow.filter(
        (seat) => !seat.taken && !seat.disabled
      );

      available.forEach((seat) => selectSeat(seat));
      return;
    }

    // 🔥 ASIENTO INDIVIDUAL
    const seat = availableSeats
      .flatMap((row) => row.seats)
      .find((s) => s.uniqueId === value);

    if (seat) {
      selectSeat(seat);
    }
  };

  const handleChooseSeats = async () => {
    if (!user) {
      Swal.fire({
        icon: 'warning',
        title: '¡Atención!',
        text: 'Debes estar logueado para continuar con la compra.',
        confirmButtonText: 'Iniciar sesión',
      }).then((result) => {
        if (result.isConfirmed) navigate('/login');
      });
      return;
    }

    setShowMap(true);

    if (!isFloresta) {
      try {
        const response = await axios.get("/zones");
        const zones = response.data.zones;

        const matchedZones = zones.filter(z => z.showId === event.id);

        const presentations = matchedZones.flatMap(zone =>
          zone.location.map(loc => ({
            zoneId: zone.id,
            divisionName: loc.division,
            presentation: event.presentation[0],
            location: zone.location,
            generalPrice: loc.generalPrice,
            generalTicket: zone.generalTicket ?? false,
          }))
        );


        setAvailablePresentations(presentations);
        setIsSelectorOpen(true);

      } catch (error) {
        console.error("Error cargando zonas dinámicas:", error);
      }
    }
  };
  const handleCloseModal = () => {
    // Cierra el modal
    setIsSeatManagerOpen(false);

    // Redirige al usuario a la página principal
    navigate('/');
  };

  const handleSeatSelection = (e) => {
    const selectedSeatId = e.target.value;
    const selected = availableSeats.find(seat => seat.id === selectedSeatId);
    setSelectedSeat(selected);  // Actualiza el asiento seleccionado
  };

  const handleShareClick = () => {
    const currentUrl = window.location.href;

    Swal.fire({
      title: 'Compartir Evento',
      html: `
      <p>Copiá el enlace para compartir este evento:</p>
      <input id="share-url" type="text" readonly value="${currentUrl}" style="width: 100%; padding: 8px; margin-top: 10px; border-radius: 5px; border: 1px solid #ccc;" />
      <button id="copy-button" style="margin-top: 10px; padding: 8px 16px; background-color: #3085d6; color: white; border: none; border-radius: 5px; cursor: pointer;">
        Copiar
      </button>
    `,
      showConfirmButton: false,
      didOpen: () => {
        const copyBtn = document.getElementById('copy-button');
        const input = document.getElementById('share-url');

        copyBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(input.value).then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Enlace copiado',
              text: '¡Ya podés compartirlo!',
              timer: 1500,
              showConfirmButton: false
            });
          }).catch(() => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo copiar el enlace.',
            });
          });
        });
      }
    });
  };



  if (isLoading) {
    return (
      <div className="loading-overlay">
        <div className="corner-img top-left" style={{ backgroundImage: 'url(/images/solticket.png)' }}></div>
        <div className="corner-img top-right" style={{ backgroundImage: 'url(/images/solticket.png)' }}></div>
        <div className="corner-img bottom-left" style={{ backgroundImage: 'url(/images/solticket.png)' }}></div>
        <div className="corner-img bottom-right" style={{ backgroundImage: 'url(/images/solticket.png)' }}></div>

        <div className="spinner"></div>
        <p>Procesando su compra...</p>
      </div>
    );
  }





  if (!event) return <div>Cargando evento...</div>



  return (
    <div className="event-detail">


      <div className="max-w-4xl mx-auto mt-[90px]">
        {/* Imagen o video arriba */}
        <div className="w-full rounded-md overflow-hidden shadow-md">
          <h1 className="flex items-center  font-semibold text-white">{event.name}</h1>
          {event.coverImage.includes("youtube.com") || event.coverImage.includes("youtu.be") ? (
            <div className="relative pt-[56.25%]">
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-md"
                src={event.coverImage.replace("watch?v=", "embed/")}
                title={event.name}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <img
              className="w-full h-auto object-cover rounded-md"
              src={event.coverImage}
              alt={event.name}
            />
          )}
        </div>

        {/* Información abajo */}
        <div className="mt-6 space-y-4 text-gray-800 text-sm md:text-base">
          <div>
            <a
              onClick={handleShareClick}
              className="primary text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Compartir 🔗
            </a>
          </div>
          <div className="flex items-center gap-2">
            <FaMusic className="text-black" />
            <p className='font-semibold text-gray-400'><strong>Género:</strong> {event.genre.join(', ')}</p>
          </div>
          <div className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-red-600" />
            <p className='font-semibold text-gray-400'><strong>Dirección y Lugar:</strong> {event.location}</p>
          </div>

          {event.presentation.map((presentation, index) => (
            <div key={index} className="flex flex-col md:flex-row md:justify-between gap-2 md:gap-6">
              <div className="flex items-center gap-2">
                <FaCalendarAlt className="text-green-600" />
                <p className='font-semibold text-gray-400'><strong>Fecha:</strong> {presentation.date}</p>
              </div>
              <div className="flex items-center gap-2">
                <FaClock className="text-red-500" />
                <p className='font-semibold text-gray-400'><strong>Horarios:</strong> {presentation.time.start} - {presentation.time.end}</p>
              </div>
              {/* Lógica para el countdown */}
              {countdownStarted && (
                <div className="flex items-center gap-2 font-semibold text-white ">
                  <h2>
                    {Math.floor(timer / 60)}:{timer % 60 < 10 ? '0' : ''}{timer % 60}
                  </h2>
                </div>
              )}

            </div>
          ))}
        </div>
      </div>

      {/* Modal selector */}
      {isSelectorOpen && (
        <div
          className="fixed inset-0 z-[9999] flex items-start justify-center pt-[80px] sm:pt-[120px] px-4 bg-black/50 backdrop-blur-sm animate-fadeIn"
          onClick={() => setIsSelectorOpen(false)}
        >
          <div
            className="w-full max-w-lg max-h-[70vh] bg-blue-500/40 backdrop-blur-md border border-white/20 p-4 rounded-2xl shadow-2xl flex flex-col animate-scaleIn"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <h3 className="text-xl font-bold text-center text-white mb-4">
              Selecciona una fecha y hora
            </h3>

            {/* Contenedor interno */}
            <div className="bg-blue-500/10 backdrop-blur-md rounded-xl p-3 overflow-y-auto overscroll-contain space-y-3 flex-1 border border-white/10 scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent">

              {availablePresentations.map((presentation, index) => (
                <div
                  key={index}
                  className="secondary backdrop-blur-sm text-white border border-white/10 rounded-xl p-4 shadow-sm hover:shadow-lg hover:scale-[1.02] hover:bg-white/10 transition duration-200"
                >
                  {/* Info */}
                  <div className="space-y-1 text-sm sm:text-base text-center">
                    <p>
                      <span className="font-semibold">División:</span>{" "}
                      {Array.isArray(presentation.divisionName)
                        ? presentation.divisionName.join(", ")
                        : presentation.divisionName}
                    </p>

                    <p>
                      <span className="font-semibold">Fecha:</span>{" "}
                      {presentation.presentation.date}
                    </p>

                    <p>
                      <span className="font-semibold">Hora:</span>{" "}
                      {presentation.presentation.time.start} -{" "}
                      {presentation.presentation.time.end}
                    </p>
                  </div>

                  {/* Botón centrado */}
                  <div className="mt-4 flex justify-center">
                    <button
                      onClick={() => handleConfirmSelection(presentation)}
                      className="px-6 py-2 rounded-lg primary font-medium hover:opacity-90 hover:scale-105 shadow-lg shadow-black/30 transition duration-200"
                    >
                      Ingresar
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="mt-6 text-center">
              <button
                onClick={() => navigate("/")}
                // onClick={() => setIsSelectorOpen(false)}
                className="secondary hover:text-white transition"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Aquí el resto de la lógica de tu página */}
      <div>
        {!showMap && (
          <button
            onClick={handleChooseSeats}
            className="secondary mt-auto text-gray-400 font-semibold rounded py-2 transition"

          >
            Elegir Asientos
          </button>
        )}

        {user?.isAdmin && (
          <>
            <button
              className="secondary mt-auto text-gray-400 font-semibold rounded py-2 transition"

              onClick={() => setIsZoneEditorOpen(true)}>Cargar datos</button>

            {isZoneEditorOpen && (
              <>
                <ZoneEditor show={event} />

                <button className='boton-adddata' onClick={() => setIsZoneEditorOpen(false)}>Cerrar</button>
              </>
            )}
          </>
        )}

        {showMap && (
          <div className="flex flex-col items-center mt-6 w-full">

            <div
              ref={scrollContainerRef}
              className="
        w-screen
        overflow-x-auto
        px-2 md:px-6
      "
              style={{
                width: isFloresta ? "auto" : "1400px",
                maxWidth: "100vw",
                height: "auto",
                display: "block"
              }}
            >

              <div className="flex justify-center">

                <canvas
                  ref={canvasRef}
                  onClick={handleCanvasClick}
                  width={isFloresta ? canvasWidth : 1400}
                  height={isFloresta ? canvasHeight : 900}
                  className="border block"
                  style={{
                    width: isFloresta ? "auto" : "1400px",
                    maxWidth: "100vw",
                    height: "auto",
                    touchAction: "pan-x pan-y pinch-zoom"
                  }}
                />
              </div>
            </div>

            {selectedZone && <p className="mt-4 font-semibold">Division Seleccionada: {selectedZone}</p>}

            <div className="flex flex-row justify-center items-center gap-10 mt-4 flex-wrap">

              {/* SELECT FILAS */}
              <div className="relative w-[120px] ml-2">
                <select
                  onChange={handleRowChange}
                  className="
        appearance-none
        w-full
        rounded-xl
        bg-white/10
        backdrop-blur-md
        border border-white/20
        text-white
        px-2 py-2
        pr-8
        shadow-lg
        transition-all duration-200
        focus:outline-none
        focus:ring-2
        focus:ring-blue-400
        focus:border-blue-400
        hover:bg-white/15
      "
                >
                  <option className="text-black" value="">
                    Seleccionar fila
                  </option>

                  {rows.map((row) => (
                    <option
                      key={row.row}
                      value={row.row}
                      className="text-black"
                    >
                      Fila {row.row}
                    </option>
                  ))}
                </select>

                {/* Flecha */}
                <div className="pointer-events-none absolute absolute right-[-30px] top-1/2 -translate-y-1/2 flex items-center text-white">
                  ▼
                </div>
              </div>

              {/* SELECT ASIENTOS */}
              <div className="relative w-[120px]">
                <select
                  onChange={handleSelectSeatFromDropdown}
                  disabled={!seatsInRow.length}
                  className={`
        appearance-none
        w-full
        rounded-xl
        backdrop-blur-md
        border
        px-2 py-2
        pr-8
        shadow-lg
        transition-all duration-200
        focus:outline-none
        focus:ring-2
        focus:ring-blue-400
        ${seatsInRow.length
                      ? "bg-white/10 border-white/20 text-white hover:bg-white/15"
                      : "bg-gray-700/40 border-gray-600 text-gray-400 cursor-not-allowed"}
      `}
                >
                  <option className="text-black" value="">
                    {seatsInRow.length
                      ? "Asiento"
                      : "Primero elegí una fila"}
                  </option>

                  {seatsInRow.length > 0 && (
                    <option className="text-black" value="ROW_ALL">
                      👉 Seleccionar toda la fila
                    </option>
                  )}

                  {seatsInRow.map((seat) => (
                    <option
                      key={seat.uniqueId}
                      value={seat.uniqueId}
                      className="text-black"
                    >
                      Asiento {seat.id} {seat.taken ? "(ocupado)" : ""}
                    </option>
                  ))}
                </select>

                {/* Flecha */}
                <div className="pointer-events-none absolute absolute right-[-30px] top-1/2 -translate-y-1/2 flex items-center text-white">
                  ▼
                </div>
              </div>
            </div>

            {selectedSeats.length > 0 && !isSeatManagerOpen && (
              <button
                className="bg-blue-900 text-gray-400 px-5 py-2 mt-4 rounded-lg text-base font-medium transition"
                onClick={() => setIsSeatManagerOpen(true)}
              >
                Continuar con la compra de {selectedSeats.length} asiento(s)
              </button>
            )}

            <Link to="/">
              <button className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md font-bold hover:bg-blue-700 transition">
                Ir a Inicio
              </button>
            </Link>
          </div>
        )}

      </div>
      <div className="zoom-controls">
        {/* <button onClick={handleZoomOut}>-</button>
        <button onClick={handleZoomIn}>+</button> */}
      </div>
      {isSeatManagerOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          style={{ zIndex: 1050 }} // ⬅️ Aca el z-index alto
        >
          <div
            className="bg-white w-[95%] max-w-3xl p-6 rounded-lg shadow-xl overflow-y-auto max-h-[90vh] relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botón de cerrar */}
            <button
              onClick={() => setIsSeatManagerOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-xl font-bold"
            >
              ×
            </button>

            <Seatbuy
              seats={selectedSeats[0]}
              onSeatsSelected={handleSeatsSelected}
              availableSeats={availableSeats}
              isSelectable={true}
              selectedSeats={selectedSeats}
              eventDetails={event}
              selectedPresentation={selectedPresentation}
              zoneId={selectedSeats[0]?.zoneId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Detail;
